<template>
  <span v-text="text" />
</template>

<script>
import { Dimension } from '@/models/Report/IntervalReport'
const dimensionItems = [
  { value: Dimension.INSERTION_ORDER, text: '案件' },
  { value: Dimension.CAMPAIGN, text: 'キャンペーン' },
  { value: Dimension.DELIVERY_GROUP, text: '地点グループ' },
]

export default {
  name: 'IntervalReportListDimension',
  props: {
    value: {
      type: String,
      default: '',
      validator(value) {
        return Object.values(Dimension).includes(value)
      },
    },
  },
  computed: {
    text() {
      return dimensionItems.find(item => item.value === this.value).text
    },
  },
}
</script>
